module.exports = __webpack_public_path__ + "img/lock.8ec95d25.svg";